<ng-container>
    <button
        *ngIf="buttonType !== 'overflow'"
        [hidden]="ttDisabled === 'hidden'"
        [matTooltip]="tooltipText"
        [matTooltipShowDelay]="500"
        [ngClass]="buttonClasses"
        (click)="onClick($event)"
        [style.fontSize]="'calc(var(--ag-font-size) - 2px)'"
        [disabled]="ttDisabled"
    >
        <span *ngIf="!!icon" class="fa-fw" [ngClass]="loading === true ? 'far fa-sync-alt fa-spin ' : icon" [style.fontSize]="!this.ttKind ? '1.8rem' : 'var(--tt-font-size)'"></span>
        <span *ngIf="!!secondIcon" class="fa-fw tt-grid__button-icon--secondary" [ngClass]="secondIcon"></span>

        <span [style.fontSize]="'var(----ag-grid-fontSize)'" *ngIf="!!text">{{ text }}</span>
    </button>
    <tt-overflow-menu
        *ngIf="buttonType === 'overflow'"
        [hidden]="ttDisabled === 'hidden'"
        [ttClasses]="buttonClasses"
        [ttText]="text"
        ttTranslateText="false"
        [ttTooltipText]="tooltipText"
        ttTranslateTooltip="false"
        [ttIcon]="icon || 'fal fa-ellipsis-v'"
    >
        <tt-overflow-menu-item
            *ngFor="let item of ttItems"
            [hidden]="item._disabled === 'hidden'"
            [ttHasDivider]="item.cssClass?.includes('seperator')"
            [ttIcon]="item.icon"
            [ttText]="getOverflowItemText(item)"
            [ttTranslateText]="item.translate"
            [ttTooltipText]="item.tooltip"
            [ttTranslateTooltipText]="item.translateTooltip"
            [ttDanger]="item.cssClass?.includes('danger')"
            (ttClick)="onClick($event, item)"
            [ttDisabled]="item._disabled"
        ></tt-overflow-menu-item>
    </tt-overflow-menu>
</ng-container>
